import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({ selector: '[acadvTwoDecimalOnly]' // You will use this as an attribute on the input element
 })
export class TwoDecimalOnlyDirective implements AfterViewInit, OnDestroy {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  private inputElement!: HTMLInputElement;
  private inputEventListener!: any;

  
  
  

  // We use AfterViewInit to ensure that the child input element is available.
  ngAfterViewInit() {
    // Query for the input element inside the custom component (aca-input).
    this.inputElement = this.el.nativeElement.querySelector('input');

    if (this.inputElement) {
      // Listen for input event on the input element
      this.inputEventListener = this.renderer.listen(this.inputElement, 'input', (event: any) => {
        this.onInputChange(event);
      });
    }
  }

  // Clean up the event listener when the directive is destroyed
  ngOnDestroy() {
    if (this.inputEventListener) {
      this.inputEventListener();
    }
  }

  onInputChange(event: any) {
    const regex = /^[0-9]*(\.[0-9]{0,2})?$/;
    const value = this.inputElement?.value || '';

    // Validate the value against the regex

      if (regex.test(value)) {
        this.inputElement.value = value;
      } else {
        // Remove invalid character if the value doesn't match the regex
        this.inputElement.value = value.slice(0, -1) || '';
        // Dispatch input event to update Angular form control
        const newEvent = new Event('input', { bubbles: true });
        this.inputElement!.dispatchEvent(newEvent);
      }
      event.stopPropagation();
   }
}
